import type { DocSection } from '../types'

export const toolsSection: DocSection = {
  id: 'communication',
  title: 'Communication & répertoire',
  icon: 'message-circle',
  accent: '#14B8A6',
  summary: "Les outils du quotidien : messagerie interne, répertoire des postes, scripts d'appel.",
  minRole: 'agent',
  articles: [
    {
      id: 'messagerie',
      title: 'Messagerie interne',
      summary: 'Discuter avec vos collègues sans quitter PexiTalk.',
      icon: 'message-circle',
      blocks: [
        { type: 'p', text: "La **Messagerie** (barre latérale → Messages) permet d'échanger en interne : **messages directs**, **groupes**, et **canal d'équipe**. Un **badge** signale les messages non lus, même quand la page Messages n'est pas ouverte." },
        { type: 'list', items: [
          "Vous recevez des **notifications** (toast + notification système) à l'arrivée d'un message.",
          "Vous pouvez joindre des **documents** (taille limitée par la configuration).",
        ] },
        { type: 'callout', variant: 'info', title: 'Suppression & archivage', text: "Un **Propriétaire** peut tout supprimer ; un **Administrateur**, les groupes. Les groupes **archivés** sont purgés au bout de 6 mois (un bandeau prévient 15 jours avant)." },
      ],
    },
    {
      id: 'repertoire',
      title: 'Répertoire interne',
      summary: 'Trouver et appeler un collègue par son poste.',
      icon: 'users',
      blocks: [
        { type: 'p', text: "Le **Répertoire** (barre latérale) liste les **postes** de vos collègues. Utile pour les **appels internes** et les **transferts** : vous appelez un collègue directement par son extension." },
        { type: 'callout', variant: 'tip', text: "Accessible à **tous les rôles**. Pour transférer un appel en cours vers un collègue, voir [[appels/transfert|Transférer un appel]]." },
      ],
    },
    {
      id: 'scripts',
      title: "Scripts d'appel",
      summary: "Le texte qui vous guide pendant l'appel.",
      icon: 'file-text',
      blocks: [
        { type: 'p', text: "Un **script** est le texte affiché pendant l'appel pour vous guider (accroche, argumentaire, traitement des objections). Il peut venir de la **campagne** (défini par un responsable) ou de **vos scripts personnels**." },
        { type: 'p', text: "La page **Scripts** (barre latérale) vous laisse consulter et gérer vos scripts. Pendant un appel, le script de la campagne s'affiche automatiquement dans l'espace de travail — voir [[appels/pendant|Pendant l'appel]]." },
      ],
    },
    {
      id: 'entraide',
      title: "Demander de l'aide (lever la main)",
      summary: 'Signaler à un superviseur que vous avez besoin d\'un coup de main.',
      icon: 'hand',
      blocks: [
        { type: 'p', text: "Le bouton **Aide** (main, barre du haut) permet de **lever la main** : les superviseurs voient immédiatement votre demande dans la Supervision et peuvent venir vous aider — par message, ou en se greffant sur votre appel (écoute, souffleur)." },
        { type: 'steps', items: [
          "Cliquez sur **Aide** dans la barre du haut — le bouton passe en « Main levée ».",
          "Continuez votre travail : un superviseur est prévenu.",
          "Re-cliquez pour **baisser la main** quand c'est réglé.",
        ] },
        { type: 'callout', variant: 'tip', text: "Pendant un appel difficile, levez la main **sans raccrocher** : un superviseur peut vous souffler des réponses sans que le client n'entende rien." },
      ],
    },
  ],
}
